import React from 'react';
import { ModalContainer, Paragraph, tokens } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { Container, ButtonContainer } from './ModalDelete.styles';
import { ReactComponent as Warning } from 'App/assets/img/warning.svg';

type ModalDeleteProps = {
	name: string;
	isLoading: boolean;
	onDelete: () => void;
	onClose: () => void;
};

export const ModalDelete = ({
	name,
	isLoading,
	onDelete,
	onClose,
}: ModalDeleteProps) => {
	return (
		<ModalContainer
			visible
			width="450px"
			height="280px"
			closeOnlyOnTheButton
			headerIcon={<Warning />}
		>
			<Container>
				<Paragraph
					textAlign="center"
					padding="0px 25px 20px 20px"
					fontSize="16px"
					fontWeight="600"
				>{`Estás por eliminar ${name}`}</Paragraph>
				<Paragraph textAlign="center" padding="0 0 25px 0">
					Los colaboradores no se eliminarán, solo dejarán de estar vinculados a
					este perfil
				</Paragraph>
				<ButtonContainer>
					<Button onClick={onDelete} width="150px" disabled={isLoading}>
						Eliminar perfil
					</Button>
					<a onClick={!isLoading ? onClose : undefined}>
						<Paragraph
							color={
								isLoading ? tokens.color_gray_medium : tokens.color_primary
							}
							textAlign="center"
							cursor={isLoading ? 'not-allowed' : 'pointer'}
							fontWeight="500"
						>
							Cancelar
						</Paragraph>
					</a>
				</ButtonContainer>
			</Container>
		</ModalContainer>
	);
};
